export const SUBMIT_FORM = 'ahsValidation/SUBMIT_FORM';
export const CUSTOMER_VALIDATED = 'ahsValidation/CUSTOMER_VALIDATED';
export const SHOW_OFFER = 'ahsValidation/SHOW_OFFER';
export const CUSTOMER_BAD_REQUEST = 'ahsValidation/CUSTOMER_BAD_REQUEST';
